import { render, staticRenderFns } from "./curriculum-vitae.vue?vue&type=template&id=7780e54c&"
import script from "./curriculum-vitae.vue?vue&type=script&lang=js&"
export * from "./curriculum-vitae.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports